// removed by extract-text-webpack-plugin
module.exports = {"slider-img":"ImagePanel__slider-img__3r4D_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImagePanel/ImagePanel.scss
// module id = 430
// module chunks = 0